var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasPerms),expression:"hasPerms"}],attrs:{"size":"small","to":_vm.link}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.buttonText))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }